import styled from 'styled-components';

export const StyledOl = styled.ol`
  list-style: number;
  list-style-position: inside;

  &:not(:first-child) {
    margin-top: ${(p) => p.theme.space[3]};
  }
`;
